import { useEvent } from 'hooks'

import { constant } from './feedback-messenger-window.constant'
import { feedbackMessengerWindowSelector } from './feedback-messenger-window.selector'

export const FeedbackMessengerWindow = (() => {
	const handleChange = () => {
		const feedbackMessengerWindow = feedbackMessengerWindowSelector.getFeedbackMessengerWindow()
		const feedbackMessengerWindowSubjectInput = feedbackMessengerWindowSelector.getFeedbackMessengerWindowSubjectInput()

		if (feedbackMessengerWindow === null || feedbackMessengerWindowSubjectInput === null) {
			return
		}

		const onChange = useEvent<Event>(feedbackMessengerWindow, 'change')

		onChange.register(({ e }) => {
			if (e.target !== feedbackMessengerWindowSubjectInput) {
				return
			}

			const requiredPart = feedbackMessengerWindow.getAttribute(constant.selector.requiredSubjectPart)

			if (requiredPart !== null && !feedbackMessengerWindowSubjectInput.value.startsWith(requiredPart, 0)) {
				feedbackMessengerWindowSubjectInput.value = `${requiredPart} ${feedbackMessengerWindowSubjectInput.value}`
			}
		})
	}

	const init = () => {
		handleChange()
	}

	return {
		init,
	}
})()
